<template>
  <b-form @submit.prevent="onSubmit" novalidate class="label-bold">
    <b-row class="justify-content-end mb-3">
      <b-col cols="auto">
        <h6 class="m-0">
          <b-link href class="btn-link-dark" tabindex="-1" @click.prevent.stop="showPwd">
            <keep-alive>
              <component :is="eyeIcon" font-scale="1.3" class="mr-2" />
            </keep-alive>
            <template v-if="showPass">Hide</template>
            <template v-else>Show</template>
          </b-link>
        </h6>
      </b-col>
    </b-row>
    <b-form-group label-for="input-old-password" label-cols-sm="4" label-cols-lg="3">
      <template #label>
        Old Password
      </template>
      <b-form-input id="input-old-password" :type="passwordType" v-model="form.oldPassword" :state="isValidField('oldPassword')"  />
      <b-form-invalid-feedback :state="isValidField('oldPassword')">
        <div v-for="error in errors.oldPassword || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label-for="input-new-password" label-cols-sm="4" label-cols-lg="3">
      <template #label>
        New Password
      </template>
      <b-form-input id="input-new-password" :type="passwordType" v-model="form.newPassword" :state="isValidField('newPassword')"  />
      <b-form-invalid-feedback :state="isValidField('newPassword')">
        <div v-for="error in errors.newPassword || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label-for="input-confirm-password" label-cols-sm="4" label-cols-lg="3">
      <template #label>
        Confirm Password
      </template>
      <b-form-input id="input-confirm-password" :type="passwordType" v-model="form.confirmPassword" :state="isValidField('confirmPassword')"  />
      <b-form-invalid-feedback :state="isValidField('confirmPassword')">
        <div v-for="error in errors.confirmPassword || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-row class="justify-content-end">
      <b-col cols="auto">
        <b-button type="submit" :disabled="submitting" pill variant="outline-primary" class="pl-5 pr-5">Change Password</b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import { BIconEyeFill, BIconEyeSlashFill } from 'bootstrap-vue'
import validator from 'validator'
import MixinForm from './MixinForm'
import { PASSWORD_RULE_TYPE, isValidPassword } from '@/helpers/password'

const errorText = {
  [PASSWORD_RULE_TYPE.ONE_LOWER_LETTER]: 'one lowercase character',
  [PASSWORD_RULE_TYPE.ONE_UPPER_LETTER]: 'one uppercase character',
  [PASSWORD_RULE_TYPE.ONE_SPECIAL_CHAR]: 'one special character',
  [PASSWORD_RULE_TYPE.MIN_LENGTH]: '8 characters minimum'
}

export default {
  name: 'ChangePasswordForm',

  mixins: [MixinForm],

  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      showPass: false
    }
  },

  computed: {
    passwordType() {
      return this.showPass ? 'text' : 'password'
    },

    eyeIcon() {
      return this.showPass ? BIconEyeSlashFill : BIconEyeFill
    }
  },

  methods: {
    showPwd() {
      this.showPass = !this.showPass
    },

    errorText(parts) {
      const text = []
      Object.keys(parts).forEach(key => {
        if (!parts[key]) {
          text.push(errorText[key])
        }
      })
      return text
    },

    validate(data) {
      const errors = {}
      if (validator.isEmpty(data.oldPassword || '')) errors.oldPassword = ["Old Password can't be blank"]
      if (data.newPassword !== data.confirmPassword) errors.confirmPassword = ["The two password fields didn't match"]

      const result = isValidPassword(data.newPassword)
      if (!result.isValid) {
        errors.newPassword = this.errorText(result.parts)
      }

      return errors
    },

    prepare(data) {
      const { confirmPassword, ...rest } = data
      return rest
    }
  }
}
</script>
